import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";

export async function getCharitiesList(params: any) {
  let res = {
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  };

  if (params) {
    params = removeEmpty(params)
  }

  await Api.get(endpoints.getCharitiesList, { params }).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError('Error on get charities list')
  })

  return res
}

export async function getCharityById(params: any) {
  let res = {
    id: "",
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    status: "Active",
    disableDeckManagement: false,
    businessName: "",
    customerId:"",
    distributorId: '',
    distributorName:''
  };

  await Api.get(endpoints.getCharityById, { params }).then((response) => {
    res = response.data
    if (!res || res.id === '') {
      notificationError('Unable to get charity informations')
    }
  }).catch((err: string) => {
    notificationError('Unable to get charity informations')
  })

  return res
}

export async function createOrUpdateCharity(payload: any) {

  await Api.post(endpoints.createOrUpdateCharity, payload).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        if (response.data.return===true) {
          notificationSucces('Charity was successfully updated')
        } else {
          notificationError('Charity was not updated')
        }
      }
    } else {
      notificationError('Charity was not updated')
    }
  }).catch((err: string) => {
    notificationError('Charity was not updated')
  })

}

export async function updateCharityStatus(params: any){

  await Api.get(endpoints.updateCharityStatus, {params}).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Status changed successfully')
      }
    } else {
      notificationError('Could not update charity status')
    }
  }).catch((err: string) => {
    notificationError('Could not update charity status')
  })
}


